  if (!customElements.get('product-customer-media')) {
    customElements.define(
      'product-customer-media',
      class ProductCustomerMedia extends HTMLElement {
        constructor() {
          super();          
        }
 
        connectedCallback() {
          this.setVariables();
          this.setEvents();
        }

        setVariables() {
          this.media = this.querySelectorAll('.product-gallery__media');
          this.hiddenMedia = this.querySelectorAll('.product-gallery__media.hidden');
          this.lastVisibleMedia = this.querySelector('.product-gallery__media-last-visible');
          this.showMoreMedia = this.querySelector('.product-gallery__media-show-more-media');
          this.showLessMedia = this.querySelector('.product-gallery__media-show-less-media');
          this.videoMedia = this.querySelectorAll('video-media');
        }

        setEvents() {
          //if (this.showMoreMedia) this.showMoreMedia.addEventListener('click', this.showAllMedia.bind(this));
          if (this.showLessMedia) this.showLessMedia.addEventListener('click', this.hideAllMedia.bind(this));
          this.videoMedia.forEach((element) => {
            element.addEventListener('click', this.enableFullScreen.bind(this));
            element.addEventListener("fullscreenchange", this.exitFullScreen.bind(this));
          });
        }
 
        showAllMedia() {
          this.hiddenMedia.forEach((media) => {
            media.classList.remove('hidden');
            media.classList.add('displayed');
          });

          if (this.showMoreMedia) this.showMoreMedia.classList.remove('product-gallery__media-show-more-media');
        }
 
        hideAllMedia() {
          this.hiddenMedia.forEach((media) => {
            media.classList.add('hidden');
            media.classList.remove('displayed');
          });

          if (this.showMoreMedia) this.showMoreMedia.classList.add('product-gallery__media-show-more-media');
        }

        enableFullScreen() {
          let video = event.currentTarget.querySelector('video');

          if (video) {
            if (video.requestFullscreen) {
              video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) { /* Safari */
              video.webkitRequestFullscreen();
            } else if (video.msRequestFullscreen) { /* IE11 */
              video.msRequestFullscreen();
            }
          }
        }

        exitFullScreen() {
          let video = event.currentTarget.querySelector('video');

          if (video) {
            if (!document.fullscreenElement) {
              video.pause();
              video.controls = false;
            } else {
              video.controls = true;
              video.play();
            }
          }
        }
      }
    );
  }
 